(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('TarefaCtrl', TarefaCtrl);

  TarefaCtrl.$inject = [
    '$q',
    '$scope',
    '$rootScope',
    'LoadingService',
    'MessagesService',
    '$templateCache',
    'LeafletService',
    'filterFilter',
    '$routeParams',
    'TarefasService',
    'StorageService',
    'InfoWindowService',
    'AplicacoesService',
    'ItensService',
    '$uibModal',
    '$timeout',
    'UsuariosService',
    'TiposOcorrenciasService',
    'PragaModalService'
  ];

  //eslint-disable-next-line max-params,max-lines-per-function
  function TarefaCtrl($q, $scope, $rootScope, LoadingService, MessagesService,
    $templateCache, LeafletService, filterFilter,
    $routeParams, TarefasService, StorageService,
    InfoWindowService, AplicacoesService, ItensService,
    $uibModal, $timeout, UsuariosService, TiposOcorrenciasService, PragaModalService) {
    const vm = this;
    const map = LeafletService.getMap('propriedade-map');
    let placeMarkerListener = null;

    //////////////////////////////////////////
    // Controller data
    vm.task = {
      markers: [],
      markersDeleted: [],
      glebas: [],
      pragas: []
    };
    vm.datePickerOptions = {
      showWeeks: false
    };
    vm.iwTemplate = null;
    vm.tipos = TAREFA_TIPOS;
    vm.status = TAREFA_STATUS;
    vm.popupData = {
      openedDataInicial: false,
      openedDataFinal: false,
      format: 'dd/MM/yyyy'
    };
    vm.customRepeatingTasks = false;
    vm.repeatingTasks = [];
    vm.markerToDelete = null;
    vm.openContextMenu = false;
    vm.rightClickPosition = [0, 0];

    //////////////////////////////////////////
    // Bindable methods
    vm.showHistory = showHistory;
    vm.changeTipo = changeTipo;
    vm.isTipoStand = isTipoStand;
    vm.isTipoProdutividade = isTipoProdutividade;
    vm.isTipoOcorrencia = isTipoOcorrencia;
    vm.openPragasModal = openPragasModal;
    vm.openPopupData = openPopupData;
    vm.changeData = changeData;
    vm.save = save;
    vm.removeMarker = removeMarker;
    vm.deleteTask = deleteTask;
    vm.padraoEmbrapaPontos = padraoEmbrapaPontos;
    vm.isValidEmbrapaPontos = isValidEmbrapaPontos;
    vm.changeGlebasSelected = changeGlebasSelected;
    vm.setRepeatingAmount = setRepeatingAmount;
    vm.encarregados = encarregados;

    //////////////////////////////////////////
    // Function declarations

    function showHistory() {
      $scope.$emit('activateSidebar', 'tasks');
    }

    function setNumberIcon(marker, index) {
      L.setOptions(marker, {
        icon: LeafletService.createIconByNumber(index, CIRCLE_COLOR.previsto.substring(1))
      });
    }

    function rightClickEvent(marker) {
      marker.on('contextmenu', (event) => {
        const { originalEvent } = event;
        $timeout(() => {
          vm.markerToDelete = marker;
          vm.openContextMenu = true;
          vm.rightClickPosition = [originalEvent.pageX, originalEvent.pageY];
        });
      });
    }

    function changeTipo() {
      vm.task.parametros = {};
      assignLastRecordValues();
    }

    function openPragasModal() {
      LoadingService.showLoading();
      TiposOcorrenciasService.list({ noPaginate: true })
        .then(function(data) {
          LoadingService.hideLoading();
          return PragaModalService.open(data.data || [], vm.task.pragas);
        })
        .then((pragas) => PragaModalService.mergePragas(pragas, $scope.pragas))
        .then((pragas) => pragas.forEach((praga) => $scope.addPraga(praga)))
        .catch(function(error) {
          if (error) {
            console.error('Erro ao buscar pragas', error);
            MessagesService.alert('Erro ao carregar pragas');
          }
        });
    }

    $scope.searchPragas = function($select) {
      $scope.searchPraga = $select.search;
      $scope.praga = { selected: null };
      $scope.pragas = null;
      if ($scope.searchPraga.length >= 3) {
        $scope.loadingPragas = true;
        TiposOcorrenciasService.list({
          descricao: $select.search
        }).then(function(data) {
          $scope.pragas = data.data || [];
        })
          .catch(function(error) {
            console.error('Erro ao buscar praga', error);
            MessagesService.alert('Erro ao carregar praga');
          })
          .finally(function() {
            $scope.loadingPragas = false;
          });
      }
    };

    $scope.addPraga = function($select) {
      if ($select && $select.id) {
        const praga = filterFilter(vm.task.pragas, { id: $select.id }, true) || [];
        if (!praga || praga.length <= 0) {
          vm.task.pragas = (vm.task.pragas || []).concat($select);
        }
      }

      $scope.praga.selected = null;
      $scope.pragas = null;
    };

    $scope.removePraga = function(index) {
      vm.task.pragas.splice(index, 1);
    };

    function assignLastRecordValues() {
      if (isTipoStand() || isTipoProdutividade()) {
        LoadingService.showLoading();

        TarefasService
          .getDefaultValues({ tipo: _.get(vm, 'task.tipo.tipo'), gleba: _.map(vm.task.glebas, 'id').join() })
          .then((result) => vm.task.parametros = _.get(result, 'data.parametros') || {})
          .finally(LoadingService.hideLoading)
          .catch((error) => {
            console.error('Não foi possível trazer as informações da última tarefa', error);
            MessagesService.alert('Não foi possível trazer as informações da última tarefa');
          });
      }
    }

    function getDate() {
      const date = $routeParams.date || new Date();
      const actualDate = moment();
      const otherDate = moment(date);

      if (otherDate.isAfter(actualDate, 'days')) {
        return otherDate.toDate();
      }

      return actualDate.toDate();
    }

    function isTipoStand() {
      return TarefasService.isTipoStand(_.get(vm, 'task.tipo'));
    }

    function isTipoProdutividade() {
      return TarefasService.isTipoProdutividade(_.get(vm, 'task.tipo'));
    }

    function isTipoOcorrencia() {
      // eslint-disable-next-line max-len
      return TarefasService.isTipoOcorrencia(_.get(vm, 'task.tipo')) && $rootScope.parametros.enable_sync_to_mongo; //Feature Flag libera apenas para clientes com sincronização ativa
    }

    function getCirclesFromMarkers() {
      return vm.task.markers.map((marker) => marker.circle);
    }

    function placeMarker({ position, runApply = true, markerId = null, comentario }) {
      const index = vm.task.markers.length + 1;
      const marker = TarefasService.createLeafletMarkerTask({ position, draggable: true, index });
      marker.circle = createCircle(position);
      marker.comentario = comentario;
      marker.id = markerId;

      rightClickEvent(marker);
      dragEvent(marker);
      createInfoWindow(marker);
      vm.task.markers.push(marker);
      updateMap();
      runApply && $scope.$apply();
    }

    function createCircle(position) {
      return LeafletService.createCircle({
        coordinates: position,
        options: {
          radius: RADIUS_TASK_CIRCLE,
          color: CIRCLE_COLOR.previsto,
          opacity: 0.4
        }
      });
    }

    function updateMap() {
      vm.task.markers.forEach((marker) => marker.addTo(map));
      getCirclesFromMarkers().forEach((circle) => circle.addTo(map));
    }

    function createInfoWindow(marker) {
      const infoWindowOject = {
        title: 'Comentário',
        created_at: new Date(),
        latitude: marker.getLatLng().lat,
        longitude: marker.getLatLng().lng,
        user: {
          user_name: (StorageService.get(KEY_USER) || {}).nome
        },
        accuracy: 'MANUAL',
        template: 'ponto_comentario.html'
      };
      InfoWindowService.createInfoWindow(vm.iwTemplate, null, infoWindowOject, marker);
    }

    function dragEvent(marker) {
      marker.on('move', (event) => {
        placeMarkerListener();
        marker.closePopup();
        marker.unbindPopup();
        createInfoWindow(marker);
        marker.circle.setLatLng(event.latlng);
      });
      marker.on('dragend', () => setTimeout(createplaceMarkerEvent, 500));
    }

    function openPopupData(popup) {
      vm.popupData[popup] = true;
    }

    function changeData(campoData) {
      if (vm.task.dataInicial > vm.task.dataFinal) {
        if (campoData === 'inicial') {
          vm.task.dataFinal = vm.task.dataInicial;
        } else if (campoData === 'final') {
          vm.task.dataInicial = vm.task.dataFinal;
        }
      }
    }

    function removeMarker(marker) {
      if (vm.task.id) {
        vm.task.markersDeleted.push(marker);
      }

      const id = vm.task.markers.indexOf(marker);
      const [removedMarker] = vm.task.markers.splice(id, 1);
      removedMarker.remove();
      removedMarker.circle.remove();
      recreateMarkers();
    }

    function recreateMarkers() {
      const currentMarkers = vm.task.markers;
      vm.task.markers = [];
      currentMarkers.forEach((marker) => {
        const position = marker.getLatLng();
        marker.remove();
        marker.circle.remove();
        placeMarker({
          position,
          runApply: false,
          markerId: marker.id,
          comentario: marker.comentario
        });
      });
    }

    function saveOrUpdateTarefa() {
      const saveOrUpdate = vm.task.id ?
        TarefasService.update(vm.task) :
        TarefasService.save(vm.task, vm.repeticao, vm.customRepeatingTasks && vm.repeatingTasks);

      saveOrUpdate.then(finish, function(error) {
        LoadingService.hideLoading();
        if (error.data && error.data.glebas) {
          MessagesService.alert(error.data.glebas[0]);
        } else if (error.data && error.data.insumo) {
          MessagesService.alert(error.data.insumo);
        } else {
          MessagesService.alert('Não foi possível salvar a tarefa! Tente novamente!');
        }
      });
    }

    function save(form) {
      if (!validateSave(form)) {
        return;
      }

      const isNewRecord = !vm.task.id;

      LoadingService.showLoading();
      if (isNewRecord && vm.task.glebas.length) {
        return associarCultivar(vm.task).then(function(result) {
          vm.task.cultivar = result;
          saveOrUpdateTarefa();
        }, function(error) {
          console.error('Falha ao configurar a cultivar da tarefa', error);
          MessagesService.alert('Falha ao configurar a cultivar da tarefa');
        });
      }

      saveOrUpdateTarefa();
    }

    function validateStandProdutividade() {
      if (!isTipoStand() && !isTipoProdutividade()) {
        return true;
      }

      if ((vm.task.glebas || []).length !== 1) {
        MessagesService.alert('Preencha um talhão.');
        return false;
      }

      return true;
    }

    function validatePontos() {
      if (!(vm.task.markers || []).length) {
        MessagesService.alert('Informe pelo menos um ponto no mapa.');
        return false;
      }

      return true;
    }

    function validateSave(form) {
      return !form.$invalid &&
          validatePontos() &&
          validateStandProdutividade();
    }

    function associarCultivar(result) {
      const deferred = $q.defer();

      AplicacoesService.listSeedings({
        safra: vm.task.safra.id,
        gleba: result.glebas[0].id
      }).then(function(response) {
        const cultivares = response.data.filter(function(cultivar) {
          return cultivar.cd_item_estoque !== null && cultivar.tipo_item_estoque !== null;
        });
        if (cultivares.length) {
          selecionarCultivar(cultivares).then(deferred.resolve, deferred.reject);
        } else {
          deferred.resolve();
        }
      })
        .catch(deferred.reject);

      return deferred.promise;
    }

    function selecionarCultivar(cultivares) {
      const deferred = $q.defer();

      const plantios = cultivares.map(function(cultivar) {
        return {
          atividade: cultivar.cd_atividade,
          cultivar: cultivar.cd_item_estoque
        };
      });

      ItensService.listCultivares({
        item: cultivares.map(function(cultivar) {
          return cultivar.cd_item_estoque;
        }).join(','),
        tipo_item: cultivares[0].tipo_item_estoque
      }).then(function(realCultivares) {
        if (realCultivares.data.length > 1) {
          modalCultivar(realCultivares.data, plantios).then(deferred.resolve, deferred.reject);
        } else {
          const cultivar = realCultivares.data[0];
          vm.task.atividade_id = plantios.find((plantio) => plantio.cultivar === cultivar.item_id).atividade;
          deferred.resolve(cultivar);
        }
      })
        .catch(deferred.reject);

      return deferred.promise;
    }

    function modalCultivar(cultivares, plantios) {
      const deferred = $q.defer();

      LoadingService.hideLoading();
      $scope.tempCultivares = {
        cultivares: cultivares,
        selected: null
      };
      const modal = $uibModal.open({
        scope: $scope,
        templateUrl: 'cultivarSelection.html',
        backdrop: 'static'
      });
      modal.result.then(function(selection) {
        vm.task.atividade_id = plantios.find((plantio) => plantio.cultivar === selection.item_id).atividade;
        deferred.resolve(selection);
      }).catch(deferred.reject);

      return deferred.promise;
    }

    function finish() {
      LoadingService.hideLoading();
      MessagesService.alert('Tarefa salva com sucesso!');
      clearMap();
      showHistory();
    }

    function clearMap() {
      vm.task.markers.forEach((marker) => {
        marker.remove();
        marker.circle.remove();
      });
    }

    function createplaceMarkerEvent() {
      if (placeMarkerListener) {
        placeMarkerListener();
        placeMarkerListener = null;
      }

      placeMarkerListener = $scope.$on('mapClick', (event, data) => {
        if (!vm.openContextMenu) {
          placeMarker({
            position: data.latlng
          });
        }
      });
    }

    function processMarker(marker, index) {
      const newMarker = L.marker(marker.getLatLng(), {
        draggable: true
      });
      newMarker.objeto = marker.objeto;
      newMarker.comentario = marker.comentario;
      newMarker.id = marker.id;
      setNumberIcon(newMarker, index + 1);
      if (!marker.circle) {
        newMarker.circle = createCircle(marker.getLatLng());
      } else {
        newMarker.circle = marker.circle;
      }
      createInfoWindow(newMarker);
      rightClickEvent(newMarker);
      dragEvent(newMarker);
      return newMarker;
    }

    function addMarkersToTask(markers) {
      markers = markers.map(processMarker);
      vm.task.markers = markers;
      updateMap();
    }

    function deleteTask() {
      MessagesService.confirm('Deseja excluir a tarefa?').then(() => {
        const task = vm.task;

        LoadingService.showLoading();
        TarefasService.delete(task.id).then(() => {
          MessagesService.alert('Tarefa excluída com sucesso!');
          clearMap();
          showHistory();
        })
          .catch((error) => {
            console.error('Falha ao excluir a tarefa', error);
            MessagesService.alert('Falha ao excluir a tarefa.');
          })
          .finally(LoadingService.hideLoading);
      });
    }

    //eslint-disable-next-line complexity
    function padraoEmbrapaPontos() {
      let result = -1;
      if (vm.task.padrao_embrapa && vm.task.glebas.length) {
        const area = vm
          .task
          .glebas
          .reduce((total, gleba) => total + parseFloat(gleba.area_total), 0);

        if (area <= 10) {
          result = 6;
        }
        if (area > 10 && area <= 30) {
          result = 8;
        }
        if (area > 30 && area <= 100) {
          result = 10;
        }
        if (area > 100) {
          result = Math.ceil(area / 10);
        }
      }
      return result;
    }

    function isValidEmbrapaPontos() {
      if (vm.task.padrao_embrapa) {
        return padraoEmbrapaPontos() <= vm.task.markers.length;
      }
      return true;
    }

    function changeGlebasSelected() {
      $scope.$emit('setZoomGlebas', vm.task.glebas.map((gleba) => gleba.id));
    }

    function setRepeatingAmount(amount) {
      if (amount > vm.repeatingTasks.length) {
        while (vm.repeatingTasks.length < amount) {
          vm.repeatingTasks.push({
            date: null,
            openCalendar: false,
            tipo: null
          });
        }
      } else if (amount < vm.repeatingTasks.length) {
        vm.repeatingTasks = vm.repeatingTasks.slice(0, amount);
      }
    }

    function encarregados() {
      if (typeof vm.usuarios === 'object') {
        return vm.usuarios.filter((usuario) => usuario !== vm.task.responsavel);
      }
    }

    //////////////////////////////////////////
    // Controller logic

    LoadingService.showLoading();

    //eslint-disable-next-line complexity
    //eslint-disable-next-line max-lines-per-function, complexity
    $scope.$root.initialize.then(() => {
      if (!$scope.$root.permissions.tarefa.canManage && $scope.$root.permissions.tarefa.canRead) {
        return showHistory();
      }

      if (!$scope.$root.permissions.tarefa.canManage) {
        MessagesService.alert(ACESSO_NAO_PERMITIDO.msg);
        return $scope.$emit('activateSidebar', 'addTask');
      }

      vm.iwTemplate = $templateCache
        .get('views/infowindow_templates/infowindowoperations.tpl.html');

      if ($scope.data.task) {
        const { markers, ...task } = $scope.data.task;
        vm.task = task;
        vm.task.dataInicial = moment(vm.task.data_inicial).toDate();
        vm.task.dataFinal = moment(vm.task.data_final).toDate();
        vm.task.markersDeleted = [];

        addMarkersToTask(markers);
      } else {
        const date = getDate();
        vm.task = {
          dataInicial: date,
          dataFinal: date,
          propriedade: $scope.$root.currentPropriedade,
          safra: filterFilter($scope.$root.safras, { current: true })[0],
          markers: [],
          glebas: []
        };

        if ($scope.$root.tipoTarefa) {
          vm.task.tipo = $scope.$root.tipoTarefa;
          $scope.$root.tipoTarefa = null;
        }

        if ($scope.data.addToTask && $scope.data.addToTask.length) {
          addMarkersToTask($scope.data.addToTask);
          if (vm.task.markers.length) {
            if (_.includes(['stand', 'semeadura_afericao'], vm.task.markers[0].objeto.tipo)) {
              vm.task.tipo = TAREFA_TIPOS.find((tipo) => tipo.tipo === 'stand');
            } else if (vm.task.markers[0].objeto.tipo === 'anotacao') {
              vm.task.tipo = TAREFA_TIPOS.find((tipo) => tipo.tipo === 'geral');
            } else {
              vm.task.tipo = TAREFA_TIPOS.find((tipo) => tipo.tipo === 'ocorrencia');
            }
          }
          $scope.data.addToTask = null;
        }
      }

      if (!vm.usuarios) {
        UsuariosService.listUsuariosFiltered({ propriedade: $scope.$root.currentPropriedade.id })
          .then(function(usuarios) {
            vm.usuarios = usuarios.data;
          })
          .catch(function(error) {
            MessagesService.alert('Não foi possível carregar dados da tarefa! Tente novamente!');
            console.error('Falha ao carregar usuários da tarefa', error);
          })
          .finally(LoadingService.hideLoading);
      } else {
        LoadingService.hideLoading();
      }
    });

    createplaceMarkerEvent();

    $scope.$on('$destroy', clearMap);
  }
}());
